/** Autogenerated by public2business schematic. DO NOT CHANGE! */
/* tslint:disable */
export * from './loading.module';
export * from './loading/loading.component';
